<template>
  <el-dialog :visible="visible" :show-close="false" class="confirmGuide">
    <div class="confirmGuideMain">
      <div class="m-t-25 p-t-130 p-l-200">
        <el-button type="primary" size="medium" round @click="closeGuide">
          我知道了
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: ['visible'],
  methods: {
    closeGuide() {
      this.$emit('update:visible', false);
    },
  },
};
</script>
